const env = process.env.VUE_APP_AMPLIFY_ENV;

export const CONST = {
  ENV: env,
  IS_DEV: ["dev", "devlite", "sandbox"].includes(env),
  IS_LITE: ["lite", "devlite", "sandbox", "main"].includes(env),
};
